const filteredItems = [
  {
    id: 'all',
    label: 'global.filter.all',
  },
  {
    id: 'Draft',
    label: 'maintenance.order.filter.draft',
  },
  {
    id: 'Confirmed',
    label: 'maintenance.order.filter.confirmation',
  },
  {
    id: 'InProgress',
    label: 'maintenance.order.filter.inProgress',
  },
  {
    id: 'Verification',
    label: 'maintenance.order.filter.verification',
  },
  {
    id: 'Finished',
    label: 'maintenance.order.filter.finished',
  },
]

export default filteredItems
